import React from 'react';
import { cn } from '../../lib/utils';

interface LogoMarkProps {
  className?: string;
}

/** Vector version of the Waer mark: a tick that turns into an upward arrow. */
export const LogoMark: React.FC<LogoMarkProps> = ({ className }) => {
  const gradientId = React.useId();
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden className={cn('size-8', className)}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="32" x2="32" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7c4dff" />
          <stop offset="1" stopColor="#d946ef" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill={`url(#${gradientId})`} />
      <rect x="0.5" y="0.5" width="31" height="31" rx="8.5" stroke="white" strokeOpacity="0.2" />
      <path
        d="M9.5 16.5 13.5 22 22.5 10.5M17.5 10h5.25v5.25"
        stroke="white"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

interface LogoProps {
  className?: string;
  markClassName?: string;
}

export const Logo: React.FC<LogoProps> = ({ className, markClassName }) => (
  <span className={cn('inline-flex items-center gap-2.5', className)}>
    <LogoMark className={markClassName} />
    <span className="text-[17px] font-semibold tracking-tight text-fg">
      Waer<span className="text-brand">.</span>
    </span>
  </span>
);
